import { render, staticRenderFns } from "./Form20DirectorResolution.vue?vue&type=template&id=5383cafc&scoped=true&"
import script from "./Form20DirectorResolution.vue?vue&type=script&lang=js&"
export * from "./Form20DirectorResolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5383cafc",
  null
  
)

export default component.exports